// extracted by mini-css-extract-plugin
module.exports = {"backdrop":"Modal_backdrop__2v4k0","modal":"Modal_modal__1NtNS","slide-down":"Modal_slide-down__2G63S"};